import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-mvno.component.scss';
var FormItemMvno = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemMvno, _super);
    function FormItemMvno(element) {
        return _super.call(this, element) || this;
    }
    FormItemMvno.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-mvno__button');
    };
    FormItemMvno.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemMvno.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        // additional containers
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        var name = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var postData = '';
        var _description = this.form.querySelector('input[name=description]');
        if (_description) {
            postData += '&description=' + _description.value;
        }
        var _firstName = this.form.querySelector('input[name=first-name]');
        if (_firstName) {
            postData += '&firstname=' + _firstName.value;
        }
        var _surname = this.form.querySelector('input[name=last-name]');
        if (_surname) {
            postData += '&surname=' + _surname.value;
        }
        var _contact = this.form.querySelector('input[name=contact-number]');
        if (_contact) {
            postData += '&contact=' + _contact.value;
        }
        var _identityNumber = this.form.querySelector('input[name=sa-identity-number]');
        if (_identityNumber) {
            postData += '&saId=' + _identityNumber.value;
        }
        // loader + hide form
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/mvnoservice.jsp";
        // service
        this.formsService.postForm(url, postData).then(function (response) {
            loader.classList.remove('active');
            if (!response.data || (response.data.match(/(invalid)/gi))) {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                error.classList.add('active');
                thankYou.classList.add('active');
                success.classList.remove('active');
            }
            else {
                analyticsService.dtmFormComplete('complete', response.code);
                thankYou.classList.add('active');
                success.classList.add('active');
                error.classList.remove('active');
                name.map(function (_item) {
                    _item.innerHTML = _firstName.value;
                });
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    return FormItemMvno;
}(Base));
export { FormItemMvno };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-mvno/form-item-mvno.component.ts
// module id = 931
// module chunks = 0